// @ts-nocheck
import React, { useMemo } from "react";
import { lazy } from "react";
import { useState } from "react";
import dayjs from "dayjs";
import {
  Box,
  Button,
  Icon,
  Input,
  InputAdornment,
  TableSortLabel,
  Typography,
  Pagination,
  PaginationItem,
  useMediaQuery,
  Tooltip,
  ClickAwayListener,
  Chip,
  Divider,
} from "@mui/material";
import { Stack } from "@mui/system";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import WestIcon from "@mui/icons-material/West";
import SortArrow from "../../assets/images/sort-arrow.svg";
import AddPlus from "../../assets/images/add-plus.svg";
import Show from "../../assets/images/Show.svg";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import {
  ArrowBack,
  ArrowForward,
  Clear,
  Close,
  Search,
  Save,
  Info,
} from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { deletePartialEventAction } from "../../store/actions/eventRequest";
import {
  convertDate,
  getGeneratorName,
  phoneNumberFormat,
} from "../../utils/methods/formatters";
import "./eventPartials.css";
import LoadingOverlay from "../../components/Custom/LoadingOverlay";
import { getZebraRowSx } from "../../components/Table/zebraStripe";
import ResizeHandle from "../../components/Table/ResizeHandle";
import { widthLockSx } from "../../components/Table/widthLockSx";
import { useColumnWidths } from "../../customHooks/useColumnWidths";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
// import CreateEvent from "../create-event/CreateEvent";
const CreateEvent = lazy(() => import("../create-event/CreateEvent"));
import { CongratulationsNavButtonsVariant2 } from "../create-event/components/event-details/EventDetails";

// icons
import EditIcon from "../../assets/images/Edit-Square.svg";
import DeletePink from "../../assets/images/Delete-pink.svg";
import { CustomDialog } from "../../components/Dialog/CustomDialog";
import { alertDialogAciton } from "../../store/actions/auth";
import { hydrateWizardFromSavedEvent } from "../create-event/components/ai-creator/hydrateWizard";
import LineClamp from "../positions/components/LineClamp";
import { fetchPartialEventsAction } from "../../store/actions/partialRequests";
import {
  resetCreateEventSlice,
  confirmAndCloseCreateEventAction,
} from "../../store/actions/createEvent";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CustomDatePicker } from "../../components/Custom/DatePicker";
import { CalendarMonth } from "@mui/icons-material";
import { useEffect } from "react";
import { getUniversalDateTimeFormat } from "../../utils/methods/universalDateTimeFormat";
import GenericTransparentBtn from "../../components/Custom/GenericTransparentBtn";
import { inputRegex } from "../../utils/constants/inputRegex";
import { rowsPerPageInit } from "../../utils/constants/paginationConstants";
import RowsPerPageDropdown from "../../components/Custom/Pagination/RowsPerPageDropdown";
import { ClientTool } from "../../components/Tooltip/ClientTool";
import { USER_ROLES } from "../../staticData/userRoles";
import { isUserRole } from "../../utils/methods/storeFunc";
import DashboardFilter from "../../components/Filter/DashboardFilters";
import { ClearAllTextButton } from "../../components/Filter/ClearAllTextButton";
import { onSubmitFormNoAction } from "../../utils/methods/eventUtils";
import { useDashboardFilters } from "../../customHooks/useDashboardFilters";
import {
  extractFiltersFromState,
  applyFiltersToState,
  hasFiltersChanged,
  compareObjects,
} from "../../utils/dashboardFiltersUtils";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&.rejected": {
    backgroundColor: "#ed101070",
  },
}));

const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
  "&.MuiPaginationItem-root": {
    color: theme.palette.common.white,
  },
  "&.Mui-selected": {
    color: theme.palette.secondary.main,
  },
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  marginLeft: "10px",
  padding: "0px",
  borderRadius: "10px",

  "&:hover": {
    backgroundColor: "rgba(209, 117, 182, 0.20)",
  },
}));

const initialData = {
  search: "",
  sortOrder: "",
  sortField: "",
  dateRange: {
    startDate: "",
    endDate: "",
  },
  searchFilters: [],
  rowsPerPage: 25,
};

export const EventPartials = () => {
  const dispatch = useDispatch();

  // memo start
  const filterByOptions = useMemo(() => {
    return isUserRole(USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN)
      ? [
          {
            label: "Ongoing",
            subSort: "asc",
            value: "ongoing",
          },
          {
            label: "Upcoming",
            subSort: "asc",
            value: "upcoming",
          },
          {
            label: "Past",
            subSort: "desc",
            value: "past",
          },
          {
            label: "Cancelled",
            subSort: "asc",
            value: "cancelled",
          },
          {
            label: "Archived",
            subSort: "desc",
            value: "archived",
          },
        ]
      : [
          {
            label: "Ongoing",
            subSort: "asc",
            value: "ongoing",
          },
          {
            label: "Upcoming",
            subSort: "asc",
            value: "upcoming",
          },
          {
            label: "Past",
            subSort: "asc",
            value: "past",
          },
        ];
  }, []);
  const initialFiltersDates = useMemo(() => {
    return {
      status: false,
      startDate: "",
      endDate: "",
    };
  }, []);
  // memo end

  // Refs start...
  // const loadFiltersApiRef = React.useRef(true);
  const [isFilterInitialised, setIsFilterInitialised] = React.useState(false);
  const skipNextFetchRef = React.useRef(false);
  // Refs end...

  // Selectors start...
  const {
    partialEvents,
    totalPages,
    isLoading,
    currentPage,
    searchString,
    searchBy: searchByRedux,
    rowsPerPage: rowsPerPageRedux,
    filtersDate: filtersDateRedux,
  } = useSelector((state) => state.partialRequest);
  const { userRole } = useSelector((state) => state.auth);

  // Selectors end...

  // State variables start...
  const [rows, setRows] = React.useState([]);
  const [currentStep, setCurrenStep] = React.useState(1);
  const [count, setCount] = React.useState(0);
  const [page, setPage] = React.useState(currentPage || 1);
  const [rowsPerPage, setRowsPerPage] = React.useState(
    rowsPerPageRedux ?? rowsPerPageInit,
  );
  // const [order, setOrder] = useState("asc");
  const [open, setOpen] = useState(false);
  const [filterParams, setFilterParams] = useState({
    sortOrder: "",
    sortField: "",
  });
  // Resizable columns (per-page localStorage key)
  const { widths, setWidth, resetWidth } = useColumnWidths(
    "savedDraftsColumnWidths.v1",
  );
  const [filterDates, setFilterDates] = useState(
    filtersDateRedux ?? initialFiltersDates,
  );
  const [searchBy, setSearchBy] = React.useState(searchByRedux ?? []);
  const [searchStr, setSearchStr] = useState(searchString || "");
  const [eventInfo, setEventInfo] = useState(null);
  const [isOpeningDraft, setIsOpeningDraft] = useState(false);
  const openingDraftRef = React.useRef(false);
  const [tab, setTab] = useState("EventRequests");
  const [deleteEventModal, setDeleteEventModal] = React.useState({
    status: false,
    id: null,
    isLoading: false,
  });
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  // State variables end...

  // ====== EVENT PARTIALS FILTERS MANAGEMENT ======
  const {
    originalFilters,
    savedFilters,
    isSaving,
    isDeleting,
    isLoading: isLoadingFilters,
    saveFilters,
    loadFilters,
    deleteFilters,
    updateFilters,
  } = useDashboardFilters("event-partials-dashboard");

  const [isFilterDataUpdated, setIsFilterDataUpdated] = React.useState(
    !compareObjects(
      originalFilters?.data?.filters,
      savedFilters?.data?.filters,
    ),
  );

  React.useEffect(() => {
    if (originalFilters) {
      setIsFilterDataUpdated(
        !compareObjects(
          originalFilters?.data?.filters,
          savedFilters?.data?.filters,
        ),
      );
    } else {
      setIsFilterDataUpdated(
        !compareObjects(initialData, savedFilters?.data?.filters),
      );
    }
  }, [savedFilters, originalFilters]);

  const handleSaveEventPartialsFilters = () => {
    const currentFilters = extractFiltersFromState({
      filterParams: {...filterParams, search: searchStr},
      filterDates,
      searchBy,
      rowsPerPage,
    });

    saveFilters(
      "event-partials-dashboard",
      currentFilters,
      () => undefined,
      (error) => console.error("Error saving event partials filters:", error),
    );
  };

  // Function to clear saved filters
  const clearSavedFiltersHandler = () => {
    // 1. Define the cleared/default filter values upfront
    const clearedFilterParams = {
      sortOrder: "",
      sortField: "",
    };

    // 2. Reset all local filter state to defaults
    setFilterParams(clearedFilterParams);
    setFilterDates(initialFiltersDates);
    setSearchBy([]);
    setSearchStr("");
    setRowsPerPage(25);
    setPage(1);

    // 3. Delete saved filters from backend
    deleteFilters(
      "event-partials-dashboard",
      () => {},
      (error) => {
        console.error("Error clearing filters:", error);
      },
    );

    // 4. Immediately dispatch the API call with the cleared values so we
    //    don't rely on the useEffect chain (which could see stale closure
    //    state or skip the call via the hasFiltersChanged guard).
    //    Mark the ref so the consolidated useEffect skips its next fetch.
    skipNextFetchRef.current = true;
    dispatch(
      fetchPartialEventsAction({
        payload: {
          role: userRole,
        },
        params: {
          page: 1,
          limit: 25,
          eventName: "",
          filters: "",
          subSort: "",
          ...clearedFilterParams,
        },
        additionalData: {
          searchString: "",
          searchBy: [],
          rowsPerPage: 25,
          filtersDate: initialFiltersDates,
        },
      }),
    );
  };
  // ====== END EVENT PARTIALS FILTERS MANAGEMENT ======

  async function eventClickHandler({ contactInfo, eventInfo, step = 4 }) {
    if (openingDraftRef.current) return;
    openingDraftRef.current = true;
    setIsOpeningDraft(true);
    try {
      await hydrateWizardFromSavedEvent(dispatch, eventInfo, contactInfo);
      setCurrenStep(step);
      setTab("CreateEvent");
    } catch (error) {
      dispatch(resetCreateEventSlice());
      // The HTTP client owns the expired-session dialog for a rejected login.
      if (error?.response?.status !== 401) {
        const message = error?.response?.data?.message || error?.message;
        dispatch(alertDialogAciton({
          open: true,
          title: "Could not open draft",
          message: typeof message === "string"
            ? message
            : "The draft could not be loaded. Please try again.",
        }));
      }
    } finally {
      openingDraftRef.current = false;
      setIsOpeningDraft(false);
    }
  }

  function refreshNewEventRequest() {
    fetchEventsHandler({});
  }

  // Load filters on component mount
  React.useEffect(() => {
    if (partialEvents?.length > 0 || totalPages == 0) {
      setIsFilterInitialised(true);
      return;
    }
    
    loadFilters(
      "event-partials-dashboard",
      (savedFiltersData) => {
        const { data } = savedFiltersData || {};
        if (!data || (Object.keys(data).length === 0 && !data.filters)) {
          setIsFilterInitialised(true);
        }
      },
      (error) => {
        setIsFilterInitialised(true);
      },
    );
  }, []);

  // ====== EVENT PARTIALS FILTERS USEEFFECT HOOKS ======

  // Watch for changes in savedFilters from Redux store
  React.useEffect(() => {
    const { data } = savedFilters || {};

    if (data && (data?.filters || Object.keys(data).length > 0)) {
      const appliedFilters = applyFiltersToState(data);

      if (appliedFilters) {
        // Apply filter params
        setFilterParams((prev) => ({
          ...prev,
          sortOrder: appliedFilters.filterParams?.sortOrder || prev.sortOrder,
          sortField: appliedFilters.filterParams?.sortField || prev.sortField,
        }));

        // Apply filter dates
        if (
          appliedFilters.filterDates?.startDate ||
          appliedFilters.filterDates?.endDate
        ) {
          setFilterDates(appliedFilters.filterDates);
        }

        // Apply search filters
        if (appliedFilters.filterParams?.search) {
          setSearchStr(appliedFilters.filterParams?.search);
        }

        // Apply rows per page
        if (appliedFilters.rowsPerPage) {
          setRowsPerPage(appliedFilters.rowsPerPage);
        }
      }
      setIsFilterInitialised(true);
    }
  }, [savedFilters]);

  // ====== END EVENT PARTIALS FILTERS USEEFFECT HOOKS ======

  // Consolidated effect for fetching table data
  useEffect(() => {
    // Only proceed if filters have been initialised
    if (!isFilterInitialised) return;

    // If the clear handler already dispatched a fresh fetch, skip this cycle
    if (skipNextFetchRef.current) {
      skipNextFetchRef.current = false;
      return;
    }

    const currentFilters = extractFiltersFromState({
      filterParams: { ...filterParams, search: searchStr },
      filterDates,
      searchBy,
      rowsPerPage,
    });

    const savedData = savedFilters?.data;
    // Skip API call only if:
    // 1. Dashboard already has data, AND
    // 2. Filters are initialized, AND
    // 3. Filters haven't changed, AND
    // 4. Page matches the currentPage in Redux (pagination triggers when page !== currentPage)
    const isPageUnchanged = page === currentPage;

    // Optional optimization: skip if data exists and filters match
    if (
      (!!partialEvents.length || totalPages == 0) &&
      isFilterInitialised &&
      !hasFiltersChanged(currentFilters, savedData) &&
      isPageUnchanged
    ) {
      return;
    }

    // Use a small debounce to catch multiple state updates at once (e.g. from saved filters)
    const timeout = setTimeout(() => {
      fetchEventsHandler({});

      if (!isFilterInitialised) return;

      const currentFilters = extractFiltersFromState({
        filterParams: { ...filterParams, search: searchStr },
        filterDates,
        searchBy,
        rowsPerPage,
      });

      const savedData = savedFilters?.data;

      // Only update Redux if the filters have actually changed
      if (hasFiltersChanged(currentFilters, savedData)) {
        updateFilters("event-partials-dashboard", {
          data: { filters: currentFilters },
        });
      }
    }, 300);

    return () => {
      clearTimeout(timeout);
    };
  }, [
    isFilterInitialised,
    page,
    rowsPerPage,
    filterParams?.sortField,
    filterParams?.sortOrder,
    searchStr,
    filterDates?.startDate,
    filterDates?.endDate,
    searchBy,
    tab
  ]);

  // Handle page reset when filters change
  useEffect(() => {
    if (!isFilterInitialised) return;
    if (page !== 1) {
      setPage(1);
    }
  }, [
    rowsPerPage, 
    filterParams?.sortField, 
    filterParams?.sortOrder, 
    searchStr,
    filterDates?.startDate, 
    filterDates?.endDate, 
    searchBy,
    tab
  ]);

  React.useEffect(() => {
    setRows(partialEvents);
  }, [partialEvents]);


  const fetchEventsHandler = ({ params, successCallback }) => {
    if (!isFilterInitialised) return;
    const { status, ...rest } = filterDates;
    dispatch(
      fetchPartialEventsAction({
        payload: {
          role: userRole,
        },
        params: {
          page,
          limit: rowsPerPage,
          eventName: searchStr,
          filters: searchBy?.map((item) => item?.value)?.join(","),
          subSort: searchBy?.map((item) => item?.subSort)?.join(","),
          ...(filterParams || {}),
          ...(rest || {}),
          ...(params || {}),
        },
        additionalData: {
          searchString,
          searchBy,
          rowsPerPage,
          filtersDate: filterDates,
        },
        successCallback: () => {
          successCallback ? successCallback() : null;
        },
      }),
    );
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleSortRequest = ({ cb, field }) => {
    const newOrder = filterParams?.sortOrder === "asc" ? "desc" : "asc";
    setFilterParams((filterParams) => {
      return {
        ...filterParams,
        sortOrder: newOrder,
        sortField: field,
      };
    });
  };

  const handleSearch = (e) => {
    const value = e?.target?.value?.replace(inputRegex, "");
    setSearchStr(value);
  };

  // Back arrow of the Create Event tab: asks before discarding the build
  // in progress (steps already completed stay under the draft events).
  const closeCreateEventTabHandler = () => {
    dispatch(
      confirmAndCloseCreateEventAction(() => {
        setTab("EventRequests");
        setCurrenStep(1);
        fetchEventsHandler({});
      }),
    );
  };

  return (
    <>
      {tab === "EventRequests" ? (
        <>
          <Box
            sx={{
              padding: "20px 40px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              "@media (max-width: 600px)": {
                flexDirection: "column",
                padding: "20px 20px",
              },
            }}
          >
            <Typography
              variant={isSmallScreen ? "h3" : "h1"}
              sx={{
                "@media (max-width: 600px)": {
                  marginBottom: "15px",
                },
              }}
            >
              Saved Drafts
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "0.75rem",
                "& .MuiInputBase-root": {
                  background: "rgba(0, 0, 0, 0.01) !important",
                  boxShadow:
                    "0px 0px 30px 0px rgba(209, 117, 182, 0.20) !important",
                  borderRadius: "8px",
                  padding: "5px 20px 5px 7px",
                  "&:before": {
                    content: "none",
                  },
                  "&:after": {
                    content: "none",
                  },
                  "& svg": {
                    color: "#ffffff",
                  },
                  "& input": {
                    color: "#ffffff",
                  },
                },
                "@media (max-width: 1000px)": {
                  width: "100%",
                },
              }}
            >
              <Tooltip
                open={filterDates?.status}
                PopperProps={{
                  sx: {
                    zIndex: "1200",
                  },
                }}
                title={
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <ClickAwayListener
                      onClickAway={() => {
                        setFilterDates((prev) => ({
                          ...prev,
                          status: !prev.status,
                        }));
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "1rem",
                          padding: "0.25rem",
                        }}
                      >
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: "0.5rem",
                          }}
                        >
                          <Typography className="no-wrap">
                            Start Date:
                          </Typography>
                          <CustomDatePicker
                            name="startDate"
                            onChange={(date) => {
                              // setFieldValue("eventStart", date?.format("YYYY-MM-DD"));
                              if (!date) return;
                              setFilterDates((searchFilters) => {
                                return {
                                  ...searchFilters,
                                  startDate: date?.format("YYYY-MM-DD"),
                                };
                              });
                            }}
                            sx={{
                              "& fieldset": {
                                paddingLeft: "0.25rem",
                                paddingRight: "0.25rem",
                              },
                              padding: "0 0.5rem",
                              border: "none !important",
                              height: "2.5rem",
                              width: "14rem !important",
                            }}
                            slotProps={{
                              textField: { placeholder: "Start date" },
                              actionBar: {
                                actions: ["clear"],
                              },
                            }}
                            defaultValue={dayjs(filterDates?.startDate || "")}
                            // format={
                            //   filterDates?.startDate
                            //     ? "ddd MM/DD/YYYY"
                            //     : "MM/DD/YYYY"
                            // }
                          />
                        </Box>
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: "0.5rem",
                          }}
                        >
                          <Typography className={"no-wrap"}>
                            End Date: &nbsp;
                          </Typography>
                          <CustomDatePicker
                            name="endDate"
                            onChange={(date) => {
                              // setFieldValue("eventStart", date?.format("YYYY-MM-DD"));
                              if (!date) return;
                              setFilterDates((searchFilters) => {
                                return {
                                  ...searchFilters,
                                  endDate: date?.format("YYYY-MM-DD"),
                                };
                              });
                            }}
                            sx={{
                              "& fieldset": {
                                paddingLeft: "0.25rem",
                                paddingRight: "0.25rem",
                              },
                              padding: "0 0.5rem",
                              border: "none !important",
                              height: "2.5rem",
                              width: "14rem !important",
                            }}
                            slotProps={{
                              textField: { placeholder: "End date" },
                              actionBar: {
                                actions: ["clear"],
                              },
                            }}
                            // value={dayjs(values.eventStart)}
                            defaultValue={dayjs(filterDates?.endDate || "")}
                            // format={
                            //   filterDates?.endDate
                            //     ? "ddd MM/DD/YYYY"
                            //     : "MM/DD/YYYY"
                            // }
                          />
                        </Box>
                        <ClearAllTextButton
                          onClear={() => {
                            setFilterDates(initialFiltersDates);
                          }}
                        />
                      </Box>
                    </ClickAwayListener>
                  </LocalizationProvider>
                }
              >
                <IconButton
                  sx={{
                    marginLeft: "10px",
                    borderRadius: "4px",
                    border: "1px solid #FFF",
                    background:
                      "linear-gradient(99deg, #F0F 0%, #8F00FF 100.41%) !important",
                    boxShadow: "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
                    minWidth: "auto",
                    padding: "5px !important",
                    height: "2.25rem",
                    width: "2.25rem",
                  }}
                  onClick={(e) => {
                    setFilterDates((prev) => ({
                      ...prev,
                      status: !prev.status,
                    }));
                  }}
                >
                  <CalendarMonth
                    sx={{
                      color: "#FFF",
                    }}
                  />
                </IconButton>
              </Tooltip>
              {/* {isUserRole(USER_ROLES.ADMIN, USER_ROLES.SUPERADMIN) && ( */}
              {/*   <DashboardFilter */}
              {/*     hideIncludeArchive */}
              {/*     filterByOptions={filterByOptions} */}
              {/*     onChange={setSearchBy} */}
              {/*     value={searchBy} */}
              {/*     onClear={() => { */}
              {/*       setSearchBy([]); */}
              {/*     }} */}
              {/*   /> */}
              {/* )} */}
              <form autoComplete="off" onSubmit={onSubmitFormNoAction}>
                <Input
                  id="input-with-icon-adornment"
                  value={searchStr}
                  onChange={handleSearch}
                  placeholder="Search here"
                  // startAdornment={
                  //   <InputAdornment position="start">
                  //     <Search />
                  //   </InputAdornment>
                  // }
                  endAdornment={
                    <InputAdornment position="start">
                      {!searchStr ? (
                        <Search
                          sx={{
                            fontSize: "1.25rem",
                            // marginRight: "0.7rem"
                          }}
                        />
                      ) : (
                        <GenericTransparentBtn
                          onClick={() => {
                            setSearchStr("");
                          }}
                          style={{
                            background: "grey",
                            padding: "0.10rem",
                            borderRadius: "50%",
                            onHover: {
                              background: "grey",
                              padding: "0.10rem",
                            },
                          }}
                        >
                          <Close
                            sx={{
                              fontSize: "1rem",
                              // marginRight: "0.7rem"
                            }}
                          />
                        </GenericTransparentBtn>
                      )}
                    </InputAdornment>
                  }
                  sx={{
                    paddingLeft: "1rem !important",
                    border: "1px solid #FFF !important",
                    "@media (max-width: 1000px)": {
                      flexGrow: "1",
                      // width: "70%"
                    },
                  }}
                />
              </form>
              {/* <Input
                id="input-with-icon-adornment"
                value={searchStr}
                onChange={handleSearch}
                placeholder="Search here"
                sx={{
                  border: "1px solid #FFF !important",
                  "@media (max-width: 1000px)": {
                    flexGrow: "1",
                    // width: "70%"
                  },
                }}
                startAdornment={
                  <InputAdornment
                    position="start"
                    sx={{
                      height: "100% !important",
                      // maxWidth: "5rem !important"
                    }}
                  >
                    <FilterByFieldsModal
                      filterByOptions={[
                        {
                          label: "Event Name",
                          value: "eventName",
                        },
                        {
                          label: "Client Name",
                          value: "client",
                        },
                        {
                          label: "Contact Info",
                          value: "contact",
                        },
                        {
                          label: "Generated By",
                          value: "generatedBy",
                        },
                        {
                          label: "Venue",
                          value: "venue",
                        }
                      ]}
                      onChange={(e) => {
                        setSearchBy(e?.target?.value);
                      }}
                      value={searchBy}
                      onClear={() => {
                        setSearchBy([]);
                      }}
                    />
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                }
              /> */}
              <Tooltip title={"Create new event"}>
                <Button
                  sx={{
                    // marginLeft: "10px",
                    borderRadius: "4px",
                    border: "1px solid #FFF",
                    background:
                      "linear-gradient(99deg, #F0F 0%, #8F00FF 100.41%) !important",
                    boxShadow: "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
                    minWidth: "auto",
                    padding: "5px !important",
                  }}
                  onClick={(e) => {
                    setTab("CreateEvent");
                  }}
                >
                  <img src={AddPlus} />
                </Button>
              </Tooltip>

              {/* Save Event Partials Filters Button */}
              <Tooltip
                title={isSaving ? "Saving filters..." : "Save current filters"}
              >
                <Button
                  onClick={handleSaveEventPartialsFilters}
                  disabled={isSaving}
                  sx={{
                    borderRadius: "4px",
                    border: "1px solid #FFF",
                    background:
                      "linear-gradient(99deg, #F0F 0%, #8F00FF 100.41%) !important",
                    boxShadow: "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
                    minWidth: "auto",
                    padding: "5px !important",
                    opacity: isSaving ? 0.7 : 1,
                    cursor: isSaving ? "not-allowed" : "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px",
                    "&:hover": {
                      opacity: isSaving ? 0.7 : 0.9,
                    },
                  }}
                >
                  {isSaving ? (
                    <CircularProgress
                      size={"1.5rem"}
                      sx={{
                        color: "#FFF",
                      }}
                    />
                  ) : (
                    <Save sx={{ fontSize: "1.5rem" }} />
                  )}
                </Button>
              </Tooltip>

              {/* Currently Applied Filters */}
              <Tooltip
                title={
                  <Box
                    sx={{
                      maxWidth: 400,
                      maxHeight: 600,
                      overflowY: "auto",
                      p: 1,
                    }}
                  >
                    <Typography variant="subtitle1" fontWeight="bold">
                      Currently Applied Filters
                    </Typography>
                    {/* un saved filters */}
                    {!!isFilterDataUpdated && (
                      <>
                        <Typography
                          variant="caption"
                          fontWeight="300"
                          color="warning.main"
                          mb={1}
                        >
                          You have unsaved filter changes
                        </Typography>
                      </>
                    )}
                    <Divider color="#8F00FF" sx={{ mb: 1 }} />

                    {/* Status */}
                    <Typography variant="caption" fontWeight="bold">
                      Status
                    </Typography>
                    <Stack direction="row" flexWrap="wrap" gap={0.5} mb={1}>
                      {searchBy?.length ? (
                        searchBy.map((f) => (
                          <Chip
                            color="primary"
                            key={f.value}
                            label={f.label}
                            size="small"
                          />
                        ))
                      ) : (
                        <Chip
                          color="primary"
                          label="None"
                          size="small"
                          variant="outlined"
                        />
                      )}
                    </Stack>

                    {/* Dates */}
                    <Typography variant="caption" fontWeight="bold">
                      Dates
                    </Typography>
                    <Stack spacing={0.25} mb={1}>
                      {filterDates?.startDate || filterDates?.endDate ? (
                        <>
                          {filterDates?.startDate && (
                            <Typography variant="body2">
                              Start:{" "}
                              {dayjs(filterDates.startDate).format(
                                "MM/DD/YYYY",
                              )}
                            </Typography>
                          )}
                          {filterDates?.endDate && (
                            <Typography variant="body2">
                              End:{" "}
                              {dayjs(filterDates.endDate).format(
                                "MM/DD/YYYY",
                              )}
                            </Typography>
                          )}
                        </>
                      ) : (
                        <Typography variant="body2">
                          No date filter
                        </Typography>
                      )}
                    </Stack>

                    {/* Search */}
                    <Typography variant="caption" fontWeight="bold">
                      Search
                    </Typography>
                    <Typography variant="body2" mb={1}>
                      {searchStr || "None"}
                    </Typography>

                    {/* Sort */}
                    <Typography variant="caption" fontWeight="bold">
                      Sort
                    </Typography>
                    <Typography variant="body2" mb={1}>
                      {filterParams?.sortField
                        ? `${filterParams.sortField} (${filterParams.sortOrder})`
                        : "None"}
                    </Typography>

                    {/* Rows */}
                    <Typography variant="caption" fontWeight="bold">
                      Rows Per Page
                    </Typography>
                    <Typography variant="body2" mb={1}>
                      {rowsPerPage === 10000000000 ? "All" : rowsPerPage}
                    </Typography>

                    <Divider color="#8F00FF" sx={{ my: 1 }} />

                    {/* Clear */}
                    <Box display="flex" justifyContent="center">
                      <ClearAllTextButton
                        onClear={clearSavedFiltersHandler}
                      />
                    </Box>
                  </Box>
                }
              >
                <IconButton
                  sx={{
                    borderRadius: "4px",
                    border: "1px solid #FFF",
                    background:
                      "linear-gradient(99deg, #F0F 0%, #8F00FF 100.41%) !important",
                    boxShadow: "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
                    minWidth: "auto",
                    padding: "5px !important",
                    fontSize: "1.5rem",
                  }}
                  disabled={isDeleting}
                >
                  {isDeleting ? (
                    <CircularProgress
                      size={"1.5rem"}
                      sx={{ color: "white" }}
                    />
                  ) : (
                    <Info fontSize="1.5rem" color="primary" />
                  )}
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
          <Box>
            {isLoading || isOpeningDraft || partialEvents !== rows ? (
              <LoadingOverlay open={true} />
            ) : (
              <Box>
                <TableContainer
                  className="custom-scroll-design"
                  sx={{
                    maxWidth: "100%",
                    ...(isSmallScreen
                      ? {
                          minHeight: "calc(100vh - 323px)",
                        }
                      : {
                          height: "88vh",
                        }),
                    overscrollBehavior: "auto",
                  }}
                >
                  <Table
                    sx={{ tableLayout: "auto" }}
                    aria-label="sticky table"
                    stickyHeader
                  >
                    <TableHead>
                      <TableRow
                        sx={{
                          "& th": {
                            backgroundColor: "#D175B6 !important",
                            padding: "2px 15px",
                            fontSize: "20px",
                            color: "#ffffff",
                            borderColor: "#D175B6",
                            "& span": {
                              color: "#ffffff !important",
                            },
                          },
                          "& th:not(:last-child)": {
                            paddingRight: "0 !important",
                          },
                        }}
                      >
                        <StyledTableCell
                          sx={{
                            minWidth: "6rem",
                            position: "relative",
                            ...widthLockSx(widths["eventName"]),
                          }}
                        >
                          <TableSortLabel
                            sx={{
                              padding: "2px 15px 2px 35px",
                              textWrap: "nowrap",
                              // fontSize: "1rem"
                            }}
                            active={true}
                            direction={
                              filterParams?.sortField === "eventName"
                                ? filterParams?.sortOrder
                                : "desc"
                            }
                            onClick={() =>
                              handleSortRequest({
                                cb: ({ row }) => {
                                  return row?.eventName?.toLowerCase();
                                },
                                field: "eventName",
                              })
                            }
                            IconComponent={(props) => (
                              <IconButton {...props}>
                                <Icon>{<img src={SortArrow} />}</Icon>
                              </IconButton>
                            )}
                          >
                            Event Name
                          </TableSortLabel>
                          <ResizeHandle
                            onResize={(px) => setWidth("eventName", px)}
                            onReset={() => resetWidth("eventName")}
                          />
                        </StyledTableCell>
                        <StyledTableCell
                          // colSpan={1}
                          sx={{
                            minWidth: "5rem",
                            position: "relative",
                            ...widthLockSx(widths["eventStart"]),
                          }}
                        >
                          <TableSortLabel
                            sx={{
                              textWrap: "nowrap",
                              // fontSize: "1rem"
                            }}
                            active={true}
                            direction={
                              filterParams?.sortField === "eventStart"
                                ? filterParams?.sortOrder
                                : "desc"
                            }
                            onClick={() =>
                              handleSortRequest({
                                cb: ({ row }) => {
                                  return row?.eventStart;
                                },
                                field: "eventStart",
                              })
                            }
                            IconComponent={(props) => (
                              <IconButton {...props}>
                                <Icon>{<img src={SortArrow} />}</Icon>
                              </IconButton>
                            )}
                          >
                            Event Start
                          </TableSortLabel>
                          <ResizeHandle
                            onResize={(px) => setWidth("eventStart", px)}
                            onReset={() => resetWidth("eventStart")}
                          />
                        </StyledTableCell>
                        <StyledTableCell
                          // colSpan={1}
                          sx={{
                            minWidth: "5rem",
                            position: "relative",
                            ...widthLockSx(widths["eventEnd"]),
                          }}
                        >
                          <TableSortLabel
                            sx={{
                              textWrap: "nowrap",
                              // fontSize: "1rem"
                            }}
                            active={true}
                            direction={
                              filterParams?.sortField === "eventEnd"
                                ? filterParams?.sortOrder
                                : "desc"
                            }
                            onClick={() =>
                              handleSortRequest({
                                cb: ({ row }) => {
                                  return row?.eventEnd;
                                },
                                field: "eventEnd",
                              })
                            }
                            IconComponent={(props) => (
                              <IconButton {...props}>
                                <Icon>{<img src={SortArrow} />}</Icon>
                              </IconButton>
                            )}
                          >
                            Event End
                          </TableSortLabel>
                          <ResizeHandle
                            onResize={(px) => setWidth("eventEnd", px)}
                            onReset={() => resetWidth("eventEnd")}
                          />
                        </StyledTableCell>
                        <StyledTableCell
                          // colSpan={2}
                          sx={{
                            minWidth: "8rem",
                            textAlign: "center",
                            position: "relative",
                            ...widthLockSx(widths["clientName"]),
                            // fontSize: "1rem !important"
                          }}
                        >
                          Client Name
                          <ResizeHandle
                            onResize={(px) => setWidth("clientName", px)}
                            onReset={() => resetWidth("clientName")}
                          />
                        </StyledTableCell>
                        <StyledTableCell
                          // colSpan={1}
                          sx={{
                            minWidth: "10rem",
                            position: "relative",
                            ...widthLockSx(widths["contactInfo"]),
                            // fontSize: "1rem !important"
                          }}
                        >
                          Contact Info
                          <ResizeHandle
                            onResize={(px) => setWidth("contactInfo", px)}
                            onReset={() => resetWidth("contactInfo")}
                          />
                        </StyledTableCell>
                        <StyledTableCell
                          // colSpan={1}
                          sx={{
                            minWidth: "10rem",
                            position: "relative",
                            ...widthLockSx(widths["generatedBy"]),
                          }}
                        >
                          <TableSortLabel
                            sx={{
                              textWrap: "nowrap",
                              // fontSize: "1rem !important"
                            }}
                            active={true}
                            direction={
                              filterParams?.sortField === "eventCreatedBy"
                                ? filterParams?.sortOrder
                                : "desc"
                            }
                            onClick={() =>
                              handleSortRequest({
                                cb: ({ row }) => {
                                  return row?.eventStart;
                                },
                                field: "eventCreatedBy",
                              })
                            }
                            IconComponent={(props) => (
                              <IconButton {...props}>
                                <Icon>{<img src={SortArrow} />}</Icon>
                              </IconButton>
                            )}
                          >
                            Generated By
                          </TableSortLabel>
                          <ResizeHandle
                            onResize={(px) => setWidth("generatedBy", px)}
                            onReset={() => resetWidth("generatedBy")}
                          />
                        </StyledTableCell>
                        <StyledTableCell
                          sx={{
                            minWidth: "10rem",
                            position: "relative",
                            ...widthLockSx(widths["venue"]),
                          }}
                        >
                          <TableSortLabel
                            sx={{
                              textWrap: "nowrap",
                              // fontSize: "1rem !important"
                            }}
                            active={true}
                            direction={
                              filterParams?.sortField === "venue"
                                ? filterParams?.sortOrder
                                : "desc"
                            }
                            onClick={() =>
                              handleSortRequest({
                                cb: ({ row }) => {
                                  return row?.venue?.toLowerCase();
                                },
                                field: "venue",
                              })
                            }
                            IconComponent={(props) => (
                              <IconButton {...props}>
                                <Icon>{<img src={SortArrow} />}</Icon>
                              </IconButton>
                            )}
                          >
                            Venue
                          </TableSortLabel>
                          <ResizeHandle
                            onResize={(px) => setWidth("venue", px)}
                            onReset={() => resetWidth("venue")}
                          />
                        </StyledTableCell>
                        <StyledTableCell
                          // colSpan={2}
                          align="right"
                          sx={{
                            textAlign: "right !important",
                          }}
                        ></StyledTableCell>
                        {/* <StyledTableCell */}
                        {/*   sx={{ */}
                        {/*     width: "10rem", */}
                        {/*   }} */}
                        {/* ></StyledTableCell> */}
                      </TableRow>
                    </TableHead>
                    <TableBody
                      sx={{
                        "& td": {
                          borderColor: "#D175B6",
                          color: "#ffffff",
                          "& td": {},
                        },
                        "& td:not(:last-child)": {
                          paddingRight: "0 !important",
                        },
                      }}
                    >
                      {rows?.map((row, index) => (
                        <StyledTableRow
                          key={index}
                          sx={getZebraRowSx(index)}
                          // className={row?.isRejected ? "rejected" : ""}
                        >
                          <StyledTableCell sx={widthLockSx(widths["eventName"])}>
                            <Typography
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                // textWrap: "nowrap",
                                wordBreak: "break-all",
                                maxWidth: "12rem",
                                "& a": {
                                  lineHeight: "0",
                                },
                                "& img": {
                                  marginRight: "10px",
                                },
                                color: row?.isRejected ? "red" : "white",
                              }}
                            >
                              <div
                                style={{
                                  cursor: "pointer",
                                  height: "24px",
                                }}
                                onClick={() => {
                                  eventClickHandler({
                                    contactInfo: row?.contactInformationId,
                                    eventInfo: row,
                                  });
                                }}
                              >
                                <img src={Show} />
                              </div>
                              {row?.eventName}
                              {row?.isRejected ? (
                                <>
                                  <StyledIconButton
                                    color="primary"
                                    disabled={true}
                                  >
                                    <Clear color="primary" />
                                  </StyledIconButton>
                                </>
                              ) : null}
                            </Typography>
                          </StyledTableCell>
                          <StyledTableCell sx={widthLockSx(widths["eventStart"])}>
                            <Typography
                              sx={{
                                color: row?.isRejected ? "red" : "white",
                              }}
                            >
                              {/* {convertDate(row?.eventStart)} */}
                              {row?.eventStart?.includes?.("/")
                                ? convertDate(row?.eventStart)
                                : getUniversalDateTimeFormat({
                                    dateTime: row?.eventStart,
                                  })}
                            </Typography>
                          </StyledTableCell>
                          <StyledTableCell sx={widthLockSx(widths["eventEnd"])}>
                            <Typography
                              sx={{
                                color: row?.isRejected ? "red" : "white",
                              }}
                            >
                              {/* {convertDate(row?.eventEnd)} */}
                              {row?.eventEnd?.includes?.("/")
                                ? convertDate(row?.eventEnd)
                                : getUniversalDateTimeFormat({
                                    dateTime: row?.eventEnd,
                                  })}
                            </Typography>
                          </StyledTableCell>
                          <StyledTableCell sx={widthLockSx(widths["clientName"])}>
                            <ClientTool
                              disable={!row?.contactInformationId}
                              data={row?.contactInformationId}
                            >
                              <Typography
                                sx={{
                                  textAlign: "center",
                                }}
                              >
                                {row?.contactInformationId
                                  ? row?.contactInformationId.companyName
                                    ? row.contactInformationId.companyName
                                    : row.contactInformationId.firstName ||
                                        row.contactInformationId.lastName
                                      ? `${
                                          row.contactInformationId.firstName ??
                                          ""
                                        } ${
                                          row.contactInformationId.lastName ??
                                          ""
                                        }`.trim()
                                      : "N/A"
                                  : "N/A"}
                              </Typography>
                            </ClientTool>
                          </StyledTableCell>
                          <StyledTableCell sx={widthLockSx(widths["contactInfo"])}>
                            <Typography
                              sx={{
                                color: row?.isRejected ? "red" : "white",
                                width: "100%",
                                paddingLeft: row?.contactInformationId?.mobile
                                  ? "0"
                                  : "2rem",
                              }}
                            >
                              {row?.contactInformationId?.mobile
                                ? phoneNumberFormat(
                                    row?.contactInformationId?.mobile,
                                  )
                                : "N/A"}
                            </Typography>
                          </StyledTableCell>
                          <StyledTableCell sx={widthLockSx(widths["generatedBy"])}>
                            <Typography
                              sx={{
                                wordBreak: "break-all",
                                color: row?.isRejected ? "red" : "white",
                              }}
                            >
                              {getGeneratorName(row)}
                            </Typography>
                          </StyledTableCell>
                          <StyledTableCell sx={widthLockSx(widths["venue"])}>
                            <Tooltip
                              title={`${row?.venue}, ${row?.venueAddressLine1}, ${row?.venueCity}, ${row?.venueState}, ${row?.venueZipCode}`}
                            >
                              <Typography
                                sx={{
                                  color: row?.isRejected ? "red" : "white",
                                }}
                              >
                                <LineClamp
                                  text={`${row?.venue}, ${row?.venueAddressLine1}, ${row?.venueCity}, ${row?.venueState}, ${row?.venueZipCode}`}
                                  maxLines={1}
                                />
                              </Typography>
                            </Tooltip>
                          </StyledTableCell>
                          <StyledTableCell
                            align="right"
                            sx={{
                              textAlign: "right !important",
                              display: "table-cell",
                              // display: "flex",
                              // alignItems: "center",
                              // gap: "10px",
                              // padding: "10px",
                            }}
                            // colSpan={2}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "right",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <Button
                                variant="text"
                                onClick={() => {
                                  eventClickHandler({
                                    contactInfo: row?.contactInformationId,
                                    eventInfo: row,
                                    step: 1,
                                  });
                                }}
                                sx={{
                                  backgroundColor: "#C369A7",
                                  padding: "10px 10px",
                                  width: "auto",
                                  minWidth: "auto",
                                  ":hover": {
                                    backgroundColor: "#C369A7",
                                  },
                                }}
                              >
                                <img src={EditIcon} />
                              </Button>

                              <Button
                                variant="text"
                                sx={{
                                  backgroundColor: "#FFF",
                                  padding: "10px 10px",
                                  width: "auto",
                                  minWidth: "auto",
                                  ":hover": {
                                    backgroundColor: "#FFF",
                                  },
                                }}
                                onClick={() => {
                                  setDeleteEventModal({
                                    status: true,
                                    id: row?._id,
                                  });
                                }}
                              >
                                <img src={DeletePink} />
                              </Button>
                            </Box>
                          </StyledTableCell>
                          {/* <StyledTableCell */}
                          {/*   sx={{ */}
                          {/*     display: "table-cell", */}
                          {/*     // display: "flex", */}
                          {/*     // alignItems: "center", */}
                          {/*     // gap: "10px", */}
                          {/*     padding: "10px", */}
                          {/*   }} */}
                          {/*   // colSpan={2} */}
                          {/* > */}
                          {/*   <Box */}
                          {/*     sx={{ */}
                          {/*       display: "flex", */}
                          {/*       alignItems: "center", */}
                          {/*       gap: "10px", */}
                          {/*     }} */}
                          {/*   > */}
                          {/*     <Button */}
                          {/*       variant="text" */}
                          {/*       onClick={() => { */}
                          {/*         setEditEventModal({ */}
                          {/*           status: true, */}
                          {/*           data: row, */}
                          {/*         }); */}
                          {/*       }} */}
                          {/*       sx={{ */}
                          {/*         backgroundColor: "#C369A7", */}
                          {/*         padding: "10px 10px", */}
                          {/*         width: "auto", */}
                          {/*         minWidth: "auto", */}
                          {/*         ":hover": { */}
                          {/*           backgroundColor: "#C369A7", */}
                          {/*         }, */}
                          {/*       }} */}
                          {/*     > */}
                          {/*       <img src={EditIcon} /> */}
                          {/*     </Button> */}
                          {/**/}
                          {/*     {isUserRole(USER_ROLES.SUPERADMIN) && ( */}
                          {/*       <Button */}
                          {/*         variant="text" */}
                          {/*         sx={{ */}
                          {/*           backgroundColor: "#FFF", */}
                          {/*           padding: "10px 10px", */}
                          {/*           width: "auto", */}
                          {/*           minWidth: "auto", */}
                          {/*           ":hover": { */}
                          {/*             backgroundColor: "#FFF", */}
                          {/*           }, */}
                          {/*         }} */}
                          {/*         onClick={() => { */}
                          {/*           setDeleteEventModal({ */}
                          {/*             status: true, */}
                          {/*             id: row?._id, */}
                          {/*           }); */}
                          {/*         }} */}
                          {/*       > */}
                          {/*         <img src={DeletePink} /> */}
                          {/*       </Button> */}
                          {/*     )} */}
                          {/*   </Box> */}
                          {/* </StyledTableCell> */}
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Box
                  sx={{
                    "& td": {
                      display: "block",
                    },
                    display: "flex",
                    position: "relative",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "black",
                    borderRadius: "0px 0px 15px 15px",
                    borderTop: "1px solid #D175B6",
                  }}
                >
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handleChangePage}
                    siblingCount={isSmallScreen ? 0 : 1}
                    renderItem={(item) => (
                      <StyledPaginationItem
                        slots={{ previous: ArrowBack, next: ArrowForward }}
                        {...item}
                      />
                    )}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      top: "48%",
                      right: "0.5rem",
                      transform: "translateY(-50%)",
                      // height: "4rem",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    <RowsPerPageDropdown
                      value={rowsPerPage}
                      show15
                      onChange={(e) => {
                        setRowsPerPage(e?.target?.value);
                        setPage(1);
                      }}
                    />
                  </Box>
                </Box>
              </Box>
            )}
          </Box>

          {/* custom dialog for delete event */}
          <CustomDialog
            open={deleteEventModal.status}
            onClose={() => {
              setDeleteEventModal({ status: false, id: null });
              setConfirmPassword("");
            }}
            isLoading={deleteEventModal?.isLoading}
            title="Delete draft"
            message="Are you sure you want to delete this draft?"
            okLabel="Delete"
            onOk={() => {
              dispatch(
                deletePartialEventAction({
                  payload: {
                    // eventId: deleteEventModal.id,
                    data: {
                      // confirmationPassword: confirmPassword,
                    },
                  },
                  params: {
                    eventId: deleteEventModal.id,
                  },
                  beforeCallback: () => {
                    setDeleteEventModal((deleteEventModal) => {
                      return {
                        ...deleteEventModal,
                        isLoading: true,
                      };
                    });
                  },
                  afterCallback: () => {
                    setDeleteEventModal((deleteEventModal) => {
                      return {
                        ...deleteEventModal,
                        isLoading: false,
                      };
                    });
                  },
                  successCallback: () => {
                    setCount((prev) => prev + 1);
                    setDeleteEventModal({ status: false, id: null });
                    fetchEventsHandler({
                      params: {
                        page: 1,
                      },
                      successCallback: () => {
                        setPage(1);
                      },
                    });
                    dispatch(
                      alertDialogAciton({
                        open: true,
                        title: "Success",
                        message: "Draft deleted successfully.",
                      }),
                    );
                  },
                }),
              );
            }}
            // confirmPassword={true}
            // password={confirmPassword}
            // setPassword={setConfirmPassword}
          />
        </>
      ) : (
        <>
          <Box
            sx={{
              position: "relative",
            }}
          >
            <Box
              sx={{
                padding: "0.75rem 0 0 0.75rem",
              }}
            >
              <Button
                onClick={closeCreateEventTabHandler}
                sx={{
                  minWidth: "0",
                  background: "none",
                  padding: "0.5rem",
                  boxShadow: "none",
                  border: `1px solid ${getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  })}`,
                  borderRadius: "50%",
                  "&:hover": {
                    minWidth: "0",
                    background: "none",
                    padding: "0.5rem",
                    boxShadow: "none",
                    border: `1px solid ${getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    })}`,
                    borderRadius: "50%",
                  },
                }}
              >
                <WestIcon />
              </Button>
            </Box>

            <CreateEvent
              showNavigationButtons={true}
              closeHandler={closeCreateEventTabHandler}
              NavButtonsComponent={CongratulationsNavButtonsVariant2}
              navButtonsComponentProps={{
                closeHandler: closeCreateEventTabHandler,
              }}
              cStep={currentStep}
            />
          </Box>
        </>
      )}
    </>
  );
};
